import { component } from 'picoapp';
import Swiper, { Navigation, Pagination } from 'swiper';
import { fixRoot, unfixRoot } from '../../../js/utils/fix-root';
import Modal from '../../../js/utils/modal';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const mediaItems = node.querySelectorAll('.js-mediaItem');
  const mediaSliderElement = node.querySelector('.js-mediaSlider');
  const allowTouchMove = !mediaSliderElement.closest('.swiper .swiper'); // If the slider is inside another swiper, disable touch move
  const mediaSliderPrevBtn = node.querySelector('.js-mediaSliderPrevBtn');
  const mediaSliderNextBtn = node.querySelector('.js-mediaSliderNextBtn');
  const mediaSliderCount = node.querySelector('.js-mediaSliderCount');
  const mediaSliderPagination = node.querySelector('.js-mediaSliderPagination');
  const lightboxElement = node.querySelector('.js-lightbox');
  const lightboxSliderElement = node.querySelector('.js-lightboxSlider');
  const lightboxSliderCount = node.querySelector('.js-lightboxSliderCount');
  const lightboxSliderPrevBtn = node.querySelector('.js-lightboxSliderPrevBtn');
  const lightboxSliderNextBtn = node.querySelector('.js-lightboxSliderNextBtn');
  const lightboxMediaItems = node.querySelectorAll('.js-lightboxMediaItem');
  const lightboxDesktopNavItems = node.querySelectorAll('.js-lightboxDesktopNavItem');
  const lightboxCloseBtns = node.querySelectorAll('.js-lightboxCloseBtn');

  /**
   * Functions
   */
  const openLightbox = (lightbox, slider, index = 0) => {
    lightbox.open();
    slider.slideTo(index);
    fixRoot();
  };

  const closeLightbox = (lightbox) => {
    lightbox.close();
    unfixRoot();
  };

  const createMediaSlider = () => (() => new Swiper(mediaSliderElement, {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    allowTouchMove: allowTouchMove,
    navigation: {
      prevEl: mediaSliderPrevBtn,
      nextEl: mediaSliderNextBtn,
    },
    pagination: {
      el: mediaSliderPagination,
      type: 'bullets',
      bulletClass: 'product__media-slider__page-bullet',
      bulletActiveClass: 'product__media-slider__page-bullet--active',
    },
    on: {
      slideChange: (data) => {
        mediaSliderCount.textContent = data.activeIndex + 1;
      },
    },
  }))();

  const createLightboxSlider = () => new Swiper(lightboxSliderElement, {
    modules: [Navigation],
    slidesPerView: 'auto',
    navigation: {
      prevEl: lightboxSliderPrevBtn,
      nextEl: lightboxSliderNextBtn,
    },
    on: {
      slideChange: (data) => {
        lightboxSliderCount.textContent = data.activeIndex + 1;

        lightboxDesktopNavItems.forEach((item) => {
          if (parseInt(item.dataset.index, 10) === data.activeIndex) {
            item.classList.add('product__lightbox__nav-item--active');
          } else {
            item.classList.remove('product__lightbox__nav-item--active');
          }
        });
      },
    },
  });

  const initLightboxZoom = () => {
    lightboxMediaItems.forEach((item) => {
      const mediaElement = item.querySelector('img,video');
      const cursor = item.querySelector('.js-lightboxCursor');

      mediaElement.addEventListener('mousemove', (event) => {
        const { top } = mediaElement.getBoundingClientRect();

        cursor.style.top = `${event.clientY - (Math.max(top, 0))}px`;
        cursor.style.left = `${event.clientX}px`;
      });

      mediaElement.addEventListener('mouseenter', () => {
        cursor.hidden = false;
      });

      mediaElement.addEventListener('mouseout', () => {
        cursor.hidden = true;
      });

      mediaElement.addEventListener('click', () => {
        item.classList.toggle('product__lightbox__media-item--zoomed');
      });
    });
  };

  const init = () => {
    createMediaSlider();
    const lightbox = Modal(lightboxElement);
    const lightboxSlider = createLightboxSlider();

    mediaItems.forEach((item) => {
      const index = parseInt(item.dataset.index, 10);

      item.addEventListener('click', () => {
        openLightbox(lightbox, lightboxSlider, index);
      });
    });

    lightboxDesktopNavItems.forEach((item) => {
      const { index } = item.dataset;

      item.addEventListener('click', () => {
        lightboxSlider.slideTo(index);
      });
    });

    lightboxCloseBtns.forEach((btn) => {
      btn.addEventListener('click', () => closeLightbox(lightbox));
    });

    initLightboxZoom();
  };

  /**
   * Init
   */
  init();
});
